import FeatureCard from "./FeatureCard";

export type FeatureItem = {
  iconClass: string;
  title: string;
  description: string;
};

type FeatureGridProps = {
  items: FeatureItem[];
  columns?: 1 | 2 | 3;
};

export default function FeatureGrid({ items, columns = 3 }: FeatureGridProps) {
  const colClass =
    columns === 1
      ? "grid-cols-1"
      : columns === 2
        ? "grid-cols-1 sm:grid-cols-2"
        : "grid-cols-1 sm:grid-cols-2 md:grid-cols-3";

  return (
    <div className={`grid gap-6 ${colClass}`}>
      {items.map((feature) => (
        <FeatureCard
          key={feature.title}
          iconClass={feature.iconClass}
          title={feature.title}
          description={feature.description}
        />
      ))}
    </div>
  );
}
